// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge__cxrckOX5CI{margin-left:var(--dixa-size-spacer-250)}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/sidebar/cards/customFields/conversationCustomFieldsCard.module.scss"],"names":[],"mappings":"AAEA,mBACE,uCAAA","sourcesContent":["@use '@dixa/lib-shared-tokens/scss' as *;\n\n.badge {\n  margin-left: var(--dixa-size-spacer-250);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `badge__cxrckOX5CI`
};
export default ___CSS_LOADER_EXPORT___;
